import React from 'react';

import MUIIconButton, {
  IconButtonProps as MUIIconButtonProps,
} from '@mui/material/IconButton';

export type IconButtonProps = MUIIconButtonProps;

const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => {
  return (
    <MUIIconButton ref={ref} {...props}>
      {props.children}
    </MUIIconButton>
  );
});

IconButton.displayName = 'IconButton';

export default IconButton;
